import { Classes, FormGroup, Icon } from '@blueprintjs/core';
import * as _ from 'lodash-es';
import * as React from 'react';
import { connect } from 'react-redux';
import type { ThunkDispatch } from 'redux-thunk';

import { showAxiosError } from 'vms/app/AppToaster';
import type { RootState } from 'vms/app/rootReducer';
import { loadInspectionTaskResults } from 'vms/features/inspection/actions';
import {
  selectInspectionCategoriesList,
  selectCachedAvailableActiveInspectionTasksListByCategory,
  selectCachedActiveAvailableInspectionResultsByTask,
} from 'vms/features/inspection/selectors';
import type {
  InspectionTaskResult,
  InspectionCategory,
  InspectionTask,
} from 'vms/features/inspection/types';
import { bindThunk } from 'vms/tsutils';

import type { PartAddDialogEditableData } from './types';

interface DispatchProps {
  loadInspectionTaskResults: (
    vehicle: string
  ) => ReturnType<ReturnType<typeof loadInspectionTaskResults>>;
}

interface StateProps {
  categories: InspectionCategory[];
  tasks: InspectionTask[];
  resultsByTask: { [taskId: string]: InspectionTaskResult };
}

interface OwnProps {
  vehicleId: string;
  inspectionCategoryId: string | null;
  taskId: string | null;
  inspectionResultId: string | undefined;
  onChange: (update: Partial<PartAddDialogEditableData>) => void;
  taskErrors: {
    intent: string;
    helperText: JSX.Element[];
  };
}

type Props = StateProps & OwnProps & DispatchProps;

class PartQuickRequestSection extends React.Component<Props> {
  componentDidMount() {
    this.props
      .loadInspectionTaskResults(this.props.vehicleId)
      .catch((error) => showAxiosError(error));
  }

  onTaskChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const task = event.target.value;
    const { resultsByTask } = this.props;
    this.props.onChange({
      task,
      inspection_result: resultsByTask[task] ? resultsByTask[task].id : undefined,
      status: 'REQUESTED',
    });
  };

  onCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) =>
    this.props.onChange({
      inspectionCategoryId: event.target.value,
      task: null,
      inspection_result: undefined,
    });

  render() {
    return (
      <>
        <FormGroup label="Category">
          <div className={Classes.HTML_SELECT}>
            <select
              onChange={this.onCategoryChange}
              name="inspectionCategoryId"
              value={this.props.inspectionCategoryId || ''}
            >
              <option value="">---Select Category---</option>
              {this.props.categories.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
            <Icon icon="double-caret-vertical" />
          </div>
        </FormGroup>
        <FormGroup label="Task">
          <div className={Classes.HTML_SELECT}>
            <select
              onChange={this.onTaskChange}
              name="task"
              value={this.props.taskId || ''}
              disabled={!this.props.inspectionCategoryId}
            >
              <option value="">---Select Task---</option>
              {this.props.tasks.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
            <Icon icon="double-caret-vertical" />
          </div>
        </FormGroup>
      </>
    );
  }
}

const mapState = (state: RootState, ownProps: OwnProps): StateProps => {
  const tasks = ownProps.inspectionCategoryId
    ? selectCachedAvailableActiveInspectionTasksListByCategory(
        state,
        ownProps.vehicleId,
        ownProps.inspectionCategoryId
      )
    : [];
  return {
    categories: selectInspectionCategoriesList(state),
    tasks: _.sortBy(tasks, 'name'),
    resultsByTask: selectCachedActiveAvailableInspectionResultsByTask(
      state,
      ownProps.vehicleId
    ),
  };
};
const mapActions = (dispatch: ThunkDispatch<any, any, any>) => ({
  loadInspectionTaskResults: bindThunk(loadInspectionTaskResults, dispatch),
});
export default connect<StateProps, DispatchProps, OwnProps>(
  mapState,
  mapActions
)(PartQuickRequestSection);
